const initialState = {
  isLoginUser: false,
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN_REQUEST":
      return {
        ...state,
        isLoginUser: true,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isLoginUser: false,
      };
    case "LOGIN_ERROR":
      return {
        ...state,
        isLoginUser: false,
      };
    default:
      return state;
  }
};

export default LoginReducer;
